import React from 'react';
import { Card, Badge } from '../UI/Card';

const DealCard = ({ image, title, subtitle, type }) => {
  return (
    <Card hover className="overflow-hidden flex flex-col">
      <div className="relative h-44 overflow-hidden">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover"
        />
        <Badge tone="dark" className="absolute top-3 left-3">
          {type}
        </Badge>
      </div>
      <div className="p-5 flex flex-col flex-1">
        <h3 className="font-bold text-ink-900 text-[16px] mb-1.5">{title}</h3>
        <p className="text-sm text-ink-500 leading-relaxed flex-1">{subtitle}</p>
        <button className="mt-4 text-brand-600 font-semibold text-sm text-left hover:text-brand-700 transition inline-flex items-center gap-1">
          Book Now <span>&rarr;</span>
        </button>
      </div>
    </Card>
  );
};

export default DealCard;
